// extracted by mini-css-extract-plugin
export default {"ctaButton":"CtaButton_ctaButton__CQgRT","primary":"CtaButton_primary__DYCgf","secondary":"CtaButton_secondary__M4xEq"};